<lg-logo-display [logoUrl]='logoUrl()'
                  [logoText]='appName'
></lg-logo-display>

@if (!environment.production) {
  <div class='d-flex center-section align-items-center'>
    <div class='fs-2'>{{ environment.name | uppercase }}</div>
  </div>
}

@if (selectedChantier()) {
  <lg-chantier-selector
    [selectableChantiers]='selectableUserChantiers()'
    [selectedChantier]='selectedChantier()'
    (chantierSelected)='onChantierSelected($event)'
  />
}

<div class='d-flex right-section align-items-center'>
  @if (connectedUser(); as connectedUser) {
    <lg-user-widget [user]='connectedUser' (logout)='logOut()' class='pe-0' />
  }
</div>
